import {unique} from 'shared/utils/unique';

export function subscribe(subscriber: Subscriber, subscribed: List<Subscriber>): any {
  return unique<Subscriber>([...subscribed, subscriber]);
}
